/**
 * Constants for location strategy
 */

/**
 * Remote work options
 */
export const REMOTE_OPTIONS = [
  { label: 'Remote - Global', value: 'remote_global', prompt_str: "The candidate location could be anywhere globally" },
  { label: 'Remote - US Only', value: 'remote_us', prompt_str: 'The candidate location could be anywhere in USA' }
];
